// NOTE 24/08/20: This is a copy of MidSelector using the new mp-ui to
// achieve consistency while migrating. Old MidSelector will be deprecated eventually in
// favour of this one.

import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { createSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  ArticleDefinition,
  Tooltip,
  constants
} from 'mage-deps/@klarna/bubble-ui'
import {
  withHoverProps,
  withStyleSheetOverride
} from '@klarna/higher-order-components'
import { Selector } from 'mage-deps/@klarna/mp-ui'
import { translator } from 'mage-i18n'
import View from '../View'
import { actions as coreActions, selectors as coreSelectors } from 'mage-core'

const { Colors } = constants

const getDefaultStyleSheet = () => ({
  selector: {
    position: 'relative'
  },
  singleMid: {
    borderBottomWidth: 1,
    borderColor: Colors.DIVIDER_STRONG.toString(),
    borderStyle: 'solid',
    height: 60,
    paddingTop: 6
  },
  tooltip: {
    position: 'absolute',
    zIndex: 3,
    top: '130%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 240
  }
})

export function MidSelectorMPUI ({
  t,
  id,
  value,
  options,
  hover,
  styleSheet,
  onChange,
  onMouseOver,
  onMouseOut,
  disabled,
  getTooltip
}) {
  const storeLabel = t('core.midSelector.label')

  if (value && options.length === 1) {
    return (
      <View className='ellipsis' style={styleSheet.singleMid}>
        <ArticleDefinition
          id={id}
          title={storeLabel}
          content={[value]}
        />
      </View>
    )
  }

  const tooltip = getTooltip && getTooltip(value)
  const selectorOptions = options.map(({ label, key: value }) => ({ label, value }))
  return (
    <div id={id} style={styleSheet.selector} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <Selector
        borderless
        label={storeLabel}
        values={[value]}
        options={selectorOptions}
        initialValues={[selectorOptions[0].value]}
        disabled={disabled}
        onSelect={onChange}
      />
      {tooltip && hover && (
        <div style={styleSheet.tooltip}>
          <Tooltip arrow='top'>
            {tooltip}
          </Tooltip>
        </div>
      )}
    </div>
  )
}

MidSelectorMPUI.propTypes = {
  // Function which received the store name (label shown in dropdown) and returns a tooltip for the dropdown
  disabled: PropTypes.bool,
  getTooltip: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  t: PropTypes.func,
  id: PropTypes.string,
  value: PropTypes.string,
  hover: PropTypes.bool,
  styleSheet: PropTypes.shape({
    singleMid: PropTypes.object,
    selector: PropTypes.object,
    tooltip: PropTypes.object
  }),
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func
}

const mappedMids = createSelector(
  coreSelectors.getMerchantIds,
  mids => mids.map(mid => ({ key: mid, label: mid }))
)

export default R.compose(
  withHoverProps({ hover: true }),
  withStyleSheetOverride(getDefaultStyleSheet),
  connect(
    (state, props) => ({
      t: translator(state),
      value: props.value || coreSelectors.getSelectedMid(state),
      options: props.options || mappedMids(state)
    }),
    (dispatch, props) => ({
      onChange: props.onChange || (mid => dispatch(coreActions.mid.set(mid)))
    })
  )
)(MidSelectorMPUI)
